<template>
  <w-icon-wrapper icon-name='work-search-icon'>
    <path
      id='_4_Suche_Icon'
      d='M23.707,22.293l-6.82-6.82a9.509,9.509,0,1,0-1.415,1.414l6.821,6.82a1,1,0,0,0,1.414-1.414ZM9.5,17A7.5,7.5,0,0,1,4.2,4.2,7.5,7.5,0,1,1,14.8,14.8,7.448,7.448,0,0,1,9.5,17Z'
      data-name='4 Suche_Icon'
      fill='currentColor'
      transform='translate(0)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconSearch' };
</script>
